























































import { ActivityIcon } from '@/components';
import { Notification } from '@/models';
import { getActivityTypeIcon, getIcon, getSkillIcon, pascalToKebabCase, IconSize } from '@/utils';
import { getNotificationsAudioMixin } from '@/shared';
import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import NotificationItem from './NotificationItem.vue';
import NotificationModal from './NotificationModal.vue';

export default mixins(getNotificationsAudioMixin('fanfare-level')).extend({
  name: 'ActivityNotifications',
  components: {
    ActivityIcon,
    NotificationItem,
    NotificationModal,
  },
  props: {
    notifications: Array as () => Notification[],
  },
  mounted() {
    if (!this.hasNotifications) {
      this.$emit('complete');
    } else {
      this.playAudio();
    }
  },
  computed: {
    hasNotifications(): boolean {
      return this.levelNotifications.length > 0 ||
        this.skillLevelNotifications.length > 0 ||
        this.activityNotifications.length > 0;
    },
    levelNotifications(): Notification[] {
      return this.notifications.filter((n) => n.type === 'LevelNotification');
    },
    skillLevelNotifications(): Notification[] {
      return this.notifications.filter((n) => n.type === 'SkillLevelNotification');
    },
    activityNotifications(): Notification[] {
      return this.notifications.filter((n) => n.type === 'ActivityNotification');
    },
  },
  methods: {
    dismiss() {
      const notificationsToDismiss = this.levelNotifications
        .concat(this.skillLevelNotifications, this.activityNotifications);
      this.$emit('dismiss', notificationsToDismiss);
      this.stopAudio();
      this.$emit('complete');
    },
    getLevelIcon() {
      return getIcon('notification-trophy.png');
    },
    getActivityTypeIcon(activityType: string) {
      return getActivityTypeIcon(activityType, true, IconSize.medium);
    },
    getSkillName(skill: string) {
      return this.$t(`skill.${pascalToKebabCase(skill)}.name`);
    },
    getSkillIcon(skill: string) {
      return getSkillIcon(pascalToKebabCase(skill), IconSize.medium);
    },
    getActivityNotificationTitle(activityType: string, activitySubtype: string): string {
      let title = this.$t(`activity.types.${activityType}.name`);
      if (activitySubtype) {
        title += ` (${this.$t(`activity.subtypes.${activitySubtype}.name`)})`;
      }
      return title as string;
    },
  },
});
